module.exports = __webpack_public_path__ + "static/media/Ankita_Inamdar.b0ffafca.png";